import { AxiosResponse } from "axios";
import { IOrganization, INewOrganization } from "./organization.types";
import { http } from "@/utils/http";

export const organizationService = {
  getList(): Promise<AxiosResponse> {
    return http.get<IOrganization[]>("/organizations");
  },

  createOrganization(payload: INewOrganization): Promise<AxiosResponse> {
    return http.post("/organizations", payload);
  },

  updateOrganization(
    organization_id: string,
    payload: INewOrganization
  ): Promise<AxiosResponse> {
    return http.patch(`/organizations/${organization_id}`, payload);
  },
};
